import VeeValidate from 'vee-validate';
import Vue from 'vue';
import parsePhoneNumber from "libphonenumber-js/mobile";


export default ({ store, app: { router, context } }, inject) => {

    let postcode_validation_feature = store.getters.getFeature(2);

    const dictionary = {
      en: {
        messages: {
            required:  () => {
                return "This field is required"
            },
            included:  () => {
                return "This field is required"
            },
            min:() => {
                return "Looks like you've not put enough characters in!"
            },
            max:() => {
                return "Looks like you've put too many characters in!"
            },
            min_value:() => {
                return "This needs to be a higher number"
            },
            max_value:() => {
                return "This needs to be a lower number"
            },
            url:() => {
                return "This field must be a url"
            },
            email:  () => {
                return "This field must be a valid email address"
            },
            confirmed: () => {
                return "This field must match the one above"
            },
            integer: () => {
                return "This field may only contain numbers"
            }
        }
      }
    };

    if(postcode_validation_feature){


        const config = JSON.parse(postcode_validation_feature.FeatureConfig.config);
        const regex = config.regex;
        const name = config.name;

        VeeValidate.Validator.extend('postcode', {
            getMessage: () => `Must be a valid `+name,
            validate: value => {
                var strongRegex = new RegExp(
                    regex
                    );
                return strongRegex.test(value);
            }
        });


    }
    
    VeeValidate.Validator.extend('mobile_phone', {
        getMessage: () => 'Must be a valid UK mobile phone number',
        validate: value => {
            if(typeof value !== 'string') {
                return false
            }
            const parsed = parsePhoneNumber(value, {defaultCountry: 'GB', extract: false})
            return (parsed?.isValid() && parsed?.country === 'GB') ?? false
        }
    })



VeeValidate.Validator.extend('no_numbers', {
  getMessage: field => `The ${field} field must not contain numbers.`,
  validate: value => /^[^0-9]*$/.test(value)
});


    Vue.use(VeeValidate,{
        dictionary:dictionary
    });

}
